import { Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
  selector: 'review-total-comments',
  template: `
    <span class="-eva-3-ml-xsm -eva-3-mr-xsm">·</span>
    <span class="eva-3-body-2 eva-3-p -eva-3-ellipsis">
      {{count}}
    </span>
  `,
  encapsulation: ViewEncapsulation.None
})

export class ReviewTotalCommentsComponent {
  @Input() count: string;
}